<template>
  <component
    v-if="!loading && showContent"
    :is="tag"
    v-bind="$attrs"
  >
    <slot />
  </component>
  <component
    v-else-if="loading"
    :is="tag"
    v-bind="$attrs"
  >
    <slot name="loading">
      <div class="space-y-3">
        <div
          v-for="index in 3"
          :key="index"
          class="dashboard-skeleton h-4 rounded-lg"
        ></div>
      </div>
    </slot>
  </component>
  <component
    v-else
    :is="tag"
    v-bind="$attrs"
  >
    <slot name="empty">
      <div class="dashboard-empty-state">Aucune donnée disponible</div>
    </slot>
  </component>
</template>

<script>
export default {
  name: 'DashboardListState',
  inheritAttrs: false,
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    hasData: {
      type: [Boolean, Number],
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    showContent () {
      if (typeof this.hasData === 'boolean') {
        return this.hasData
      }
      if (this.hasData === null || this.hasData === undefined) {
        return false
      }
      const parsed = Number(this.hasData)
      return !Number.isNaN(parsed) && parsed > 0
    }
  }
}
</script>
